module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-list"
  }, [_c('div', {
    staticClass: "projects-container"
  }, [(_vm.showCreateProject) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "create-card"
  }, [_c('a', {
    on: {
      "click": _vm.createProject
    }
  }, [_c('i', {
    staticClass: "ppj-icon-plus"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('actions.project.new')))])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (project.id),
        expression: "project.id"
      }],
      key: project.id,
      staticClass: "item",
      class: {
        'clear-margin': index % 4 === (_vm.showCreateProject ? 2 : 3)
      }
    }, [_c('project-card', {
      attrs: {
        "project": project
      },
      on: {
        "update": function($event) {
          _vm.update($event, index)
        },
        "refresh": function($event) {
          _vm.refreshData()
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "50%"
    },
    slot: "spinner"
  }, [_c('div', {
    staticClass: "ppj-icon-spinner"
  })]), _vm._v(" "), _c('welcome', {
    on: {
      "click": _vm.createProject
    },
    slot: "no-results"
  }), _vm._v(" "), _c('p', {
    staticClass: "hint",
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('actions.category.noMore')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f761557c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/index.vue
// module id = 957
// module chunks = 3